export default __webpack_public_path__ + "static/media/5.9e888490.png";